// extracted by mini-css-extract-plugin
export default {"background":"Home_background__U5zJk","line-clamp":"Home_line-clamp__BlrE8","line-clamp-3":"Home_line-clamp-3__gGESM"};